import { useMemo, useState } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { setDocFolder } from '../lib/library';
import { listDocumentMeta } from '../lib/docMeta';
import { allFolders, normalizeFolderPath } from '../lib/folders';
import { useStore } from '../store/useStore';
import { useT } from '../i18n/useT';
import { Modal } from './Modal';

/** Move a document into an existing folder, the root, or a new folder path. */
export function MoveToFolderDialog() {
  const t = useT();
  const id = useStore((s) => s.moveToFolderFor);
  const setId = useStore((s) => s.setMoveToFolderFor);
  const docs = useLiveQuery(() => listDocumentMeta(), [], []);
  const folders = useMemo(() => allFolders(docs), [docs]);
  const [custom, setCustom] = useState('');

  if (!id) return null;
  const close = () => {
    setId(null);
    setCustom('');
  };
  const move = async (folder: string | null) => {
    await setDocFolder(id, normalizeFolderPath(folder));
    close();
  };

  return (
    <Modal onClose={close} title={t('folder.move')}>
      <ul className="mb-template-list">
        <li>
          <button className="mb-template-item" onClick={() => void move(null)}>
            {t('folder.root')}
          </button>
        </li>
        {folders.map((f) => (
          <li key={f}>
            <button className="mb-template-item" onClick={() => void move(f)}>
              {f}
            </button>
          </li>
        ))}
      </ul>
      <form
        className="mb-field"
        onSubmit={(e) => {
          e.preventDefault();
          if (custom.trim()) void move(custom);
        }}
      >
        <input
          className="mb-modal-url"
          placeholder={t('folder.newPlaceholder')}
          value={custom}
          onChange={(e) => setCustom(e.target.value)}
          aria-label={t('folder.new')}
        />
        <button className="mb-btn mb-btn-primary" type="submit" disabled={!custom.trim()}>
          {t('folder.create')}
        </button>
      </form>
      <div className="mb-modal-actions">
        <button className="mb-btn" onClick={close}>
          {t('common.cancel')}
        </button>
      </div>
    </Modal>
  );
}
